import { render, staticRenderFns } from "./imageTxtNav.vue?vue&type=template&id=a006916e&scoped=true"
import script from "./imageTxtNav.vue?vue&type=script&lang=js"
export * from "./imageTxtNav.vue?vue&type=script&lang=js"
import style0 from "./imageTxtNav.vue?vue&type=style&index=0&id=a006916e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a006916e",
  null
  
)

export default component.exports